import { render, staticRenderFns } from "./ProductNotesDialog.vue?vue&type=template&id=2c04ea73&scoped=true&lang=pug&"
import script from "./ProductNotesDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductNotesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductNotesDialog.vue?vue&type=style&index=0&id=2c04ea73&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c04ea73",
  null
  
)

export default component.exports